export const MenuItems = [
    {
        title: 'Projects',
        url: '/project',
        cName: 'nav-links'
    },
    {
        title: 'Articles',
        url: '/writing',
        cName: 'nav-links'
    },
    {
        title: 'About',
        url: '/about',
        cName: 'nav-links'
    },
]